import React from "react";
import {Drawer, Form, Button, Col, Row,Menu,Collapse, Comment, Tooltip, Avatar } from 'antd';
import { AppstoreOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons';
import moment from "moment";
import {SortData} from "../../../api/fn";

const { SubMenu } = Menu;
const { Panel } = Collapse;

function callback(key) {
    console.log(key);
}
const handleClick = e => {
    console.log('click ', e);
};
export default (props)=>{
    let {_this}=props;
    let {state}=_this;

    const onClose = () => {
        _this.setState({
            showMoreDetail:false
        });
    };

    let lsDetail=[
        /*{key:"Name",val:"Merveilleux"},
        {key:"Surname",val:"Bianagacila"},
        {key:"Birthday",val:"02-Nov-2020"},
        {key:"Profession",val:"Software Developer"},*/
    ];
    let lsStatus=[
        /*{name:"Good",color:"green",orgdatetime:"2020-12-10 15:11:20",username:"biangacila@gmail.com"},
        {name:"Warning",color:"orange",orgdatetime:"2020-12-10 21:11:20",username:"imbani12@gmail.com"},
        {name:"Follow up",color:"gray",orgdatetime:"2020-12-10 15:11:20",username:"biangacila@gmail.com"},
        {name:"Bad",color:"red",orgdatetime:"2020-12-10 15:11:20",username:"biangacila@gmail.com"},*/
    ];
    let lsPriority=[
        /*{name:"Level 1",color:"green",orgdatetime:"2020-12-09 08:11:20",username:"biangacila@gmail.com"},
        {name:"Level 2",color:"orange",orgdatetime:"2020-12-07 14:02:20",username:"imbani12@gmail.com"},*/
    ];

    let lsActivity=[
        /*{name:"Hospital",data:{name:"Observatory","Station number":"S789","File Number":15874}},
        {name:"Policy",data:{"Station Name":"Good Wood","Case Number":"SP789","Agent":"Mr Bilomba"}},*/
    ]
    let lsStage=[];
    let lsComment=[
        /*{body:"Hi! Mr Biangacila\nAm ok",subject:"Test 1",orgdatetime:"2020-12-10 15:11:20",username:"biangacila@gmail.com"}*/
    ];

    let nameOfCase = "";
    let org = "";
    let project = "";
    let ref="";

    if(state.moreDetailData!==null) {
        console.log("state.moreDetailData > ", state.moreDetailData);
        nameOfCase = state.moreDetailData.name;
        org = state.moreDetailData.record.org;
        project = state.moreDetailData.record.module;
        ref = state.moreDetailData.record.ref;

    }

    for(let i in _this.state.Comments){
        let row = _this.state.Comments[i];
        if(row.project!==project){continue}
        if(row.ref!==ref){continue}
        lsComment.push({
            body:row.body,
            subject:row.subject,
            orgdatetime:row.orgdatetime,
            username:row.username
        })
    }
    /**
     *
     * Let make our data
     *
     * */


    if(state.moreDetailData!==null){

        /**
         * detail
         * */
        for(let i in state.moreDetailData.record.data){
            let val = state.moreDetailData.record.data[i];
            lsDetail.push({
                key:i,
                val:val
            })
        }
        /**
         * Status, priority, stage, activity
         * */
        let arrData = state.Informations;
        arrData = SortData("orgdatetime",arrData);

        for(let i in arrData){
            let row=arrData[i];
            if(row.org!==org){continue}
            if(row.project!==project){continue}
            if(row.ref!==ref){continue}
            if(row.action==="status"){
                lsStatus.push(row)
            }
            if(row.action==="priority"){
               lsPriority.push(row);
            }
            if(row.action==="stage"){
                lsStage.push(row)
            }
            if(row.action==="activity"){
                lsActivity.push(row)
            }
        }


    }


    const renderComment = (dataIn)=>{
        return dataIn.map(row=>{
            return(
                <Comment
                    actions={[]}
                    author={<a>{_this.findUserName(row.username)}</a>}
                    avatar={
                        <Avatar
                            src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
                            alt={row.username}
                        />
                    }
                    content={
                        <p>
                            {row.body}
                        </p>
                    }
                    datetime={
                        <Tooltip title={moment(row.orgdatetime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')}>
                            <span>{moment(row.orgdatetime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')}</span>
                        </Tooltip>
                    }
                />
            )
        })
    }
    const renderActivity=(dataIn)=>{
        return dataIn.map(row=>{
            let innerData=[];
            for(let i in row.data){
                let rec = row.data[i];
                innerData.push({
                    key:i,
                    val:rec
                })
            }
            return(
                <div style={styles.statusBox}>
                    <div style={styles.statusTitle}>
                        <AppstoreOutlined />&nbsp;{row.name}
                    </div>
                    <div style={styles.statusBody}>
                        Agent: {_this.findUserName(row.username)}
                        <br/>
                        Created: {moment(row.orgdatetime,"YYYY-MM-DD").format("DD - MMM - YYYYY")}
                    </div>
                    <div style={styles.statusBody}>
                        {innerData.map(record=>{
                            return(
                                <p>{record.key}: {record.val}</p>
                            )
                        })}
                    </div>
                </div>
            )
        })
    }
    const renderStatus=(dataIn)=>{
        return dataIn.map(row=>{
            return(
                <div style={styles.statusBox}>
                    <div style={styles.statusTitle}>
                        <AppstoreOutlined />&nbsp;<span style={{color:row.color}}>{row.name}</span>
                    </div>
                    <div style={styles.statusBody}>
                        Agent: {_this.findUserName(row.username)}
                        <br/>
                        Created: {moment(row.orgdatetime,"YYYY-MM-DD").format("DD - MMM - YYYYY")}
                    </div>
                </div>
            )
        })
    }
    const renderDetailRecord=(row)=>{
        return(
            <div style={styles.group1Container}>
                <div style={styles.group1Title}>
                    {row.key}:
                </div>
                <div style={styles.group1Body}>
                    {row.val}
                </div>
            </div>
        )
    }
    return (
        <>
            <Drawer
                title={"Case detail : "+nameOfCase}
                width={720}
                onClose={onClose}
                visible={state.showMoreDetail}
                bodyStyle={{paddingBottom: 80}}
                footer={
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button onClick={onClose} type="primary">
                            Close
                        </Button>
                    </div>
                }
            >
                <Form layout="vertical" hideRequiredMark>
                    <Row gutter={16} style={{marginTop: 20}}>
                        <Col span={12} style={styles.group1}>
                            {lsDetail.map((row)=>{
                                return renderDetailRecord(row)
                            })}

                        </Col>
                        <Col span={12}>
                            <Collapse defaultActiveKey={[]} onChange={callback}>
                                <Panel header="Status" key="1">
                                    {renderStatus(lsStatus)}
                                </Panel>
                                <Panel header="Priority" key="2">
                                    {renderStatus(lsPriority)}
                                </Panel>
                                <Panel header="Activity" key="4">
                                    {renderActivity(lsActivity)}
                                </Panel>
                                <Panel header="Stage" key="3">
                                    {renderActivity(lsStage)}
                                </Panel>
                                <Panel header="Comment" key="5">
                                    {renderComment(lsComment)}
                                </Panel>
                            </Collapse>


                            {/*<Menu
                                onClick={handleClick}
                                style={{ width: "100%" }}
                                defaultSelectedKeys={['1']}
                                defaultOpenKeys={['sub1']}
                                mode="inline"
                            >
                                <SubMenu key="sub1" icon={<AppstoreOutlined />} title="Status">
                                    {renderStatus()}
                                    <Menu.ItemGroup key="g1" title="Item 1">
                                        <Menu.Item key="1">Option 1</Menu.Item>
                                        <Menu.Item key="2">Option 2</Menu.Item>
                                    </Menu.ItemGroup>
                                    <Menu.ItemGroup key="g2" title="Item 2">
                                        <Menu.Item key="3">Option 3</Menu.Item>
                                        <Menu.Item key="4">Option 4</Menu.Item>
                                    </Menu.ItemGroup>
                                </SubMenu>
                                <SubMenu key="sub2" icon={<AppstoreOutlined />} title="Priority">
                                    <Menu.Item key="5">Option 5</Menu.Item>
                                    <Menu.Item key="6">Option 6</Menu.Item>
                                    <SubMenu key="sub3" title="Submenu">
                                        <Menu.Item key="7">Option 7</Menu.Item>
                                        <Menu.Item key="8">Option 8</Menu.Item>
                                    </SubMenu>
                                </SubMenu>
                                <SubMenu key="sub4" icon={<SettingOutlined />} title="Stage">
                                    <Menu.Item key="9">Option 9</Menu.Item>
                                    <Menu.Item key="10">Option 10</Menu.Item>
                                    <Menu.Item key="11">Option 11</Menu.Item>
                                    <Menu.Item key="12">Option 12</Menu.Item>
                                </SubMenu>
                            </Menu>
*/}
                        </Col>
                    </Row>

                </Form>
            </Drawer>
        </>
    );
}

const styles={
    statusBox:{

    },
    statusTitle:{
        color:"lightblue",
        fontSize:18,
        fontWeight:"bold"
    },
    statusBody:{
        marginLeft:10,
        color:"gray",
        fontSize:16,
    },
    group1:{
        border:"1px solid blue",
        borderRadius:5
    },
    group1Container:{
        marginT: 10
    },
    group1Title:{
        color:"lightblack",
        fontSize:18,
    },
    group1Body:{
        fontSize:16,
        color:"gray",
        marginLeft: 10
    }
}
